<template>
    <div class="top" :style="navStyle">
        <div class="header" v-if="baseInfo.layersType === 1">
            <img class="logo" :src="logo" @click="goHome"/>
            <header-nav :routes="routes"></header-nav>
            <auth-menu :routes="routes"></auth-menu>
        </div>
        <div class="header layer-bg" v-else>
            <div class="logo-layer">
                <div class="logo-layer-container">
                    <img class="logo" :src="logo" @click="goHome"/>
                    <auth-menu :routes="routes"></auth-menu>
                </div>
            </div>
            <div class="menu-layer">
                <div class="menu-layer-container">
                    <header-nav :routes="routes"></header-nav>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.top{
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 99;
    background: var(--bg);
    background-size: cover;
    box-shadow: 0 0 10px rgba(0,0,0,.3);
}
.header{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: var(--navWidth);
    padding: var(--navPadding);
    height: 80px;
    margin: 0 auto;
    font-size: 16px;
}
.logo{
    height: 50px;
    max-width: 400px;
    cursor: pointer;
}
.layer-bg{
    flex-direction: var(--menuLayout);
    align-items: unset;
    width: unset;
    height: 150px;
    padding: 0;
    background: var(--bg);
    background-size: cover;
    .logo-layer{
        padding: var(--navPadding);
        background: var(--logoLayerBg);
        background-size: cover;
        .logo-layer-container{
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: var(--navWidth);
            height: 100px;
            margin: 0 auto;
        }
    }
    .menu-layer{
        padding: var(--navPadding);
        background: var(--menuLayerBg);
        .menu-layer-container{
            width: var(--navWidth);
            height: 50px;
            margin: 0 auto;
            /deep/ .label{
                height: 50px;
                .menu-list{
                    top: 50px;
                }
                &:nth-child(1){
                    margin-left: -20px;
                }
            }
        }
    }
}
</style>

<script>
import HeaderNav from './nav'
import AuthMenu from './auth-menu'
import { mapState } from 'vuex'
import { PaasTenant } from '@/models/paas-tenant'
import { RouteArr } from '@/models/route-arr'
export default {
    data(){
        return {
            routes: {data: []}
        }
    },
    computed: {
        ...mapState(['logo', 'baseInfo']),
        navStyle(){
            return `--menuTextColor: ${this.baseInfo.menuTextColor};` +
            `--menuSelectedColor: ${this.baseInfo.menuSelectedColor};` +
            `--bg: ${this.bg};` +
            `--menuListBg: ${this.menuListBg};` +
            `--menuLayerBg: ${this.menuLayerBg};` +
            `--logoLayerBg: ${this.logoLayerBg};` +
            `--navWidth: ${this.navWidth};` +
            `--navPadding: ${this.navPadding};` +
            `--menuLayout: ${this.baseInfo.isMenuTop ? 'column-reverse' : 'column'}`
        },
        bg(){
            if(this.baseInfo.layersType === 1){
                if(this.baseInfo.layersBackgroundType === 1){
                    return this.baseInfo.menuColor
                }
                if(this.baseInfo.layersBackgroundType === 2){
                    if(this.baseInfo.backgroundImg){
                        return `url(${this.baseInfo.backgroundImg}) no-repeat`
                    }else{
                        return '#fff'
                    }
                }
            }
            if(this.baseInfo.layersType === 2){
                if(this.baseInfo.layersLayoutType === 1){
                    if(this.baseInfo.layersBackgroundType === 1){
                        return this.baseInfo.menuColor
                    }
                    if(this.baseInfo.layersBackgroundType === 2){
                        if(this.baseInfo.backgroundImg){
                            return `url(${this.baseInfo.backgroundImg}) no-repeat`
                        }else{
                            return '#fff'
                        }
                    }
                }
            }
            return ''
        },
        menuListBg(){
            if(this.baseInfo.layersType === 1 && this.baseInfo.layersBackgroundType === 2){
                return '#fff'
            }
            if(this.baseInfo.layersType === 2 && 
                this.baseInfo.layersLayoutType === 1 && 
                this.baseInfo.layersBackgroundType === 2){
                return '#fff'
            }
            return this.baseInfo.menuColor
        },
        menuLayerBg(){
            if(this.baseInfo.layersType === 2 && this.baseInfo.layersLayoutType === 2){
                return this.baseInfo.menuColor
            }
            return ''
        },
        logoLayerBg(){
            if(this.baseInfo.layersType === 2 && this.baseInfo.layersLayoutType === 2){
                return `url(${this.baseInfo.backgroundImg}) no-repeat`
            }
            return ''
        },
        navWidth(){
            if(this.baseInfo.widthType === 1){
                return '1200px'
            }
            return ''
        },
        navPadding(){
            if(this.baseInfo.widthType === 2){
                return '0 45px'
            }
            return '0'
        }
    },
    components: {
        HeaderNav,
        AuthMenu
    },
    created(){
        this.init()
    },
    methods: {
        init(){
            PaasTenant.getNavList().then(res => {
                this.routes = new RouteArr(res)
                const active_route = res.find(r => `/${window.location.hash}` === r.path)
                if(active_route){
                    this.routes.setActive(active_route)
                }
            })
        },
        goHome(){
            this.$router.push('/')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/layout/header/index.vue